webpackJsonp([153124696304688],{

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contacts-1.8f827db5.svg";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _contacts = __webpack_require__(284);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contacts = function (_React$Component) {
		(0, _inherits3.default)(Contacts, _React$Component);
	
		function Contacts() {
			(0, _classCallCheck3.default)(this, Contacts);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Contacts.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Contacts.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
		};
	
		Contacts.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Contact with remote academic writers agency - UvoCorp.com",
					meta: [{ name: "description", content: "Freelance academic writing agency contacts." }, { property: 'og:title', content: "Contact with remote academic writers agency - UvoCorp.com" }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:description', content: "Freelance academic writing agency contacts." }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/contacts.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Contacts"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white inner-center contacts-block" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "col-sm-7 col-md-8" },
								_react2.default.createElement(
									"h2",
									{ className: "left" },
									"Our contact information"
								),
								_react2.default.createElement(
									"dl",
									{ className: "contacts-list" },
									_react2.default.createElement(
										"dt",
										null,
										"Telephone numbers:"
									),
									_react2.default.createElement(
										"dd",
										null,
										_react2.default.createElement(
											"a",
											{ href: "tel:+18667197923" },
											"1 866 719 7923"
										)
									),
									_react2.default.createElement(
										"dt",
										null,
										"Working hours:"
									),
									_react2.default.createElement(
										"dd",
										null,
										"Monday 00:00 \u2013 Saturday 12:00 PM (GMT)"
									)
								),
								_react2.default.createElement(
									"p",
									null,
									"If you have any questions or suggestions, please, contact us through ",
									_react2.default.createElement(
										"a",
										{ href: "mailto:vacancy@uvocorp.com" },
										"vacancy@uvocorp.com"
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-sm-5 col-md-4" },
								_react2.default.createElement(
									"div",
									{ className: "contacts_img contacts_img_1" },
									_react2.default.createElement("img", { src: _contacts2.default, alt: "Contacts Image1" })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Contacts;
	}(_react2.default.Component);
	
	exports.default = Contacts;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contacts-html-js-7b17965764dce1276d1a.js